import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {bulkAssignGrantResources} from 'src/openapi/admin/apis/BulkAssignGrantResourcesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';
import type {SuccessPayload} from 'src/typedef';

export const useAssignResourcesToGrant = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        const payload: {success: true, error: false, data: string[]} = {
            success: true,
            error: false,
            data: [],
        };
        return Promise.resolve({type: '', payload});
    }, []);

    const saveDispatchAction = useCallback(async (
        addedResources: string[],
        signal: AbortSignal,
        options?: {grantId: string, reason?: string},
    ) => {
        const {grantId, reason} = options ?? {};
        if (!grantId) {
            const payload: {success: false, error: true, data: Error} = {
                success: false,
                error: true,
                data: {message: 'Grant ID is required'},
            };
            return Promise.resolve({type: '', payload});
        }

        const assignResourcesResponse = await apiDispatch(bulkAssignGrantResources({
            reason,
            updateGrantResources: {
                grantId,
                resourcesId: addedResources,
            },
        }, {signal}));

        if (assignResourcesResponse.payload.success) {
            const payload: SuccessPayload<undefined> = {
                success: true,
                error: false,
                data: undefined,
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: assignResourcesResponse.payload});
        }
    }, [apiDispatch]);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
    });
};
